export default "__VITE_ASSET__DuTc3PZd__"